import React, { Component } from 'react';
import SupportCoinGrasp from "./SupportCoinGrasp";

class Footer extends Component {
    render() {
        return (
            <footer className="cg-footer">
                <div>
                    <SupportCoinGrasp />
                    <p className="cg-copyright">© Copyright CoinGrasp 2017. All rights reserved.</p>
                </div>
            </footer>
        );
    }
}

export default Footer;


// WEBPACK FOOTER //
// ./src/Footer.js